var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"volumeBarWrapper"},_vm._l((10),function(index){return _c('span',{key:index,class:{volumeGrid:true, active: index > 10-_vm.volume}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }